function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.707 21.92L21.921.707a1 1 0 111.414 1.414L2.122 23.335A1 1 0 11.707 21.92z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.121.707L23.334 21.92a1 1 0 11-1.414 1.415L.707 2.12A1 1 0 012.121.707z",
  fill: "currentColor"
});

function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAyNSI+CiAgPHBhdGggZD0iTS43MDcgMjEuOTJMMjEuOTIxLjcwN2ExIDEgMCAxMTEuNDE0IDEuNDE0TDIuMTIyIDIzLjMzNUExIDEgMCAxMS43MDcgMjEuOTJ6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICA8cGF0aCBkPSJNMi4xMjEuNzA3TDIzLjMzNCAyMS45MmExIDEgMCAxMS0xLjQxNCAxLjQxNUwuNzA3IDIuMTJBMSAxIDAgMDEyLjEyMS43MDd6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgIconCross as ReactComponent };